const IMAGES_DIRECTORY_PREFIX = 'images/promos';

const SPECIAL_HEADERS_COUNT = 2;

export {
  IMAGES_DIRECTORY_PREFIX,
  SPECIAL_HEADERS_COUNT,
};
